/** Preferencia delivery vs retiro para respuestas del asistente (independiente del checkout). */
export const ASSISTANT_SERVICE_PREF_KEY = 'soluqr_assistant_service_pref';

export function businessOffersDelivery(business) {
  return (business?.service_types || []).includes('delivery');
}

/** Dirección obligatoria solo si el local hace delivery y no ofrece retiro/mesa en el flujo. */
export function mustCollectAddressForProfile(business) {
  const serviceTypes = business?.service_types || [];
  if (!serviceTypes.includes('delivery')) return false;
  return !serviceTypes.includes('retiro') && !serviceTypes.includes('mesa');
}
